import { Autocomplete } from '@base-ui/react/autocomplete';

import type { SearchResultItem, SearchResultSource } from '../../../search.types';
import { SearchResultGroup } from './search-result-group';

type SearchResultsProps = {
    onResult: (result: SearchResultItem) => void;
    query: string;
    sources: readonly SearchResultSource[];
};

export function SearchResults({ onResult, query, sources }: Readonly<SearchResultsProps>) {
    return (
        <Autocomplete.List
            className="header-search__list"
            render={props => {
                const listProps = { ...props };
                delete listProps['aria-orientation'];

                return <div {...listProps} />;
            }}
        >
            {sources.map(source => (
                <SearchResultGroup key={source.kind} onResult={onResult} query={query} source={source} />
            ))}
        </Autocomplete.List>
    );
}
